import { ErrorWebXR } from "../errors/error.webxr";

type PermissionsConfig = {
  motion: boolean;
  camera: boolean;
  mic: boolean;
};

export const requestMotionPermission = async (): Promise<boolean> => {
  try {
    if (
      typeof DeviceMotionEvent !== "undefined" &&
      typeof (DeviceMotionEvent as any).requestPermission === "function"
    ) {
      const motionPermission = await (
        DeviceMotionEvent as any
      ).requestPermission();

      if (motionPermission === "granted") {
        return true;
      } else {
        const error = new Error("requestPermissions: permission denied");
        error.name = ErrorWebXR.MOTION_PERMISSION_DENIED;
        throw error;
      }
    } else {
      return true;
    }
  } catch (e) {
    const error = new Error("requestPermissions: permission denied");
    error.name = ErrorWebXR.MOTION_PERMISSION_DENIED;
    throw error;
  }
};

export const requestCameraPermission = async (): Promise<boolean> => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: true, 
    });
    stream.getTracks().forEach(track => track.stop());
    return true;
  } catch (e) {
    const error = new Error("requestPermissions: permission denied");
    error.name = ErrorWebXR.CAMERA_PERMISSION_DENIED;
    throw error;
  }
};

export const requestMicPermission = async (): Promise<boolean> => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: true,
    });
    stream.getTracks().forEach(track => track.stop());
    return true;
  } catch (e) {
    const error = new Error("requestPermissions: permission denied");
    error.name = ErrorWebXR.MIC_PERMISSION_DENIED; 
    throw error;
  }
};

export const requestPermissions = async (config: PermissionsConfig = { motion: true, camera: true, mic: false }): Promise<boolean> => {
  if (config.motion) {
    const motionGranted = await requestMotionPermission();
    if (!motionGranted) {
      return false;
    }
  }
  if (config.camera) {
    const cameraGranted = await requestCameraPermission();
    if (!cameraGranted) {
      return false;
    }
  }
  if (config.mic) {
    const micGranted = await requestMicPermission();
    if (!micGranted) {
      return false;
    }
  }
  return true;
};
